import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BbitWebShopAlgoliaI18nPipe, BbitWebShopAlgoliaService } from '@bbitgmbh/webshop.sdk';
import { BbitPictureSrcDirective, BbitWebsiteService } from '@bbitgmbh/website.sdk';
import { ItemPriceComponent } from '../../../helper/item-price/item-price.component';
import { ItemStockComponent } from '../../../helper/item-stock/item-stock.component';

@Component({
  selector: 'app-item-list-item',
  imports: [
    RouterLink,
    ItemStockComponent,
    ItemPriceComponent,
    BbitWebShopAlgoliaI18nPipe,
    BbitPictureSrcDirective,
    // I18nPipe,
  ],
  templateUrl: './item-list-item.component.html',
  styleUrl: './item-list-item.component.scss',
})
export class ItemListItemComponent {
  private _algolia = inject(BbitWebShopAlgoliaService);
  website = inject(BbitWebsiteService);

  readonly item = input<any>();
  readonly index = input<number>();

  registerItemClick() {
    const index = this.index();
    if (index) {
      this._algolia.itemClicked(this.item().objectID, index + 1);
    }
  }

  public showItemNumber(): boolean {
    return this.item().itemType !== '#productGroup';
  }
}
